export const CUSTOMER_COSTING_BOUNDARY = {
  LocalOrigin: 'http://localhost',
  ErrorStatus: 'CUSTOM_ERROR',
  ExchangeRateToken: 'exchange',
} as const;

export const CUSTOMER_COSTING_BOUNDARY_PATTERN = {
  ForbiddenRouteSegment: /^(?:aud|cost|costs|costing|fx)$/i,
  ForbiddenFieldToken:
    /^(?:aud|cost|costs|costing|currency|currencies|fx)$/i,
  ExchangeRateSuffix: /^rates?$/,
  AudValue: /\bAUD\b/i,
} as const;

export const CUSTOMER_COSTING_BOUNDARY_MESSAGE = {
  blockedRoute: (url: string): string => `Customer panel blocked a Costing/FX route: ${url}`,
  blockedFields: (paths: string[]): string =>
    `Customer panel blocked Costing/FX request fields: ${paths.join(', ')}`,
} as const;
